// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B6FqWZyfnGnzo6 {
  display: grid;
  height: 70px;
  padding: 0 15px;
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.B6FqWZyfnGnzo6 p {
  margin-bottom: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"totals": `B6FqWZyfnGnzo6`
};
export default ___CSS_LOADER_EXPORT___;
